import { createStyle } from '@gluestack-style/react';

export const AccordionContent = createStyle({
  px: '$5',
  mt: '$2',
  pb: '$5',
});
